import React, { Fragment, useState, useEffect, useMemo } from "react";
import { Button, Row, Form, Input, message } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUpdateBulkUpload } from "hooks/configuration/employee/employee";
import Image from 'helpers/Image';
import "../../style.css";

const FormEmployee = () => {
    let navigate = useNavigate();
    const { state } = useLocation();
    const csvData = useMemo(() => state || [], [state]);
    const [form] = Form.useForm();
    const [serverErrors, setServerErrors] = useState({});
    
    const { mutate: updateBulkUpload, isLoading: Loading } = useUpdateBulkUpload();


    useEffect(() => {
        if (csvData.length) {
            form.setFieldsValue(
                csvData.reduce((acc, row, index) => {
                    acc[`employeeCode_${index}`] = row.employeeCode || '';
                    acc[`employeeName_${index}`] = row.employeeName || '';
                    acc[`finNo_${index}`] = row.finNo || '';
                    acc[`contact_${index}`] = row.contact || '';
                    acc[`designation_${index}`] = row.designation || '';
                    acc[`company_${index}`] = row.company || '';
                    return acc;
                }, {})
            );
        }
    }, [csvData, form]);

    const onFinish = (formValues) => {
        const submitData = csvData.map((item, index) => ({
            employeeCode: formValues[`employeeCode_${index}`]?.trim() || "",
            employeeName: formValues[`employeeName_${index}`]?.trim() || "",
            finNo: formValues[`finNo_${index}`]?.trim() || "",
            contact: formValues[`contact_${index}`]?.length ? formValues[`contact_${index}`] : null,
            designation: formValues[`designation_${index}`]?.trim() || "",
            company: formValues[`company_${index}`]?.trim() || ""
        }));

        console.log(submitData);

        updateBulkUpload(submitData, {
            onSuccess: (item) => {
                if (item?.statusCode === 200) {
                    message.success(item?.message);
                    navigate("/configuration/employee");
                } else {
                    message.error(item?.message);
                }
            },
            onError: (error) => {
                if (error?.response?.data?.errorMessages) {
                    const errorMessages = error.response.data.errorMessages;
                    setServerErrors((prevState) => ({
                        employeeName: errorMessages.employeeName || prevState.employeeName,
                        finNo: errorMessages.finNo || prevState.finNo,
                        contactNumber: errorMessages.contactNumber || prevState.contactNumber,
                        designation: errorMessages.designation || prevState.designation,
                        employeeCode: errorMessages.employeeCode || prevState.employeeCode,
                        companyName: errorMessages.companyName || prevState.companyName
                    }));
                }
            },
        });
    };

    const clearError = (name, index) => {
        setServerErrors((prevState) => {
            const updatedErrors = { ...prevState };
            if (updatedErrors[name]) {
                updatedErrors[name][index] = "";
            }
            return updatedErrors;
        });
    };
    
    const handleInputChange = (index, name) => {
        clearError(name, index);
    };

    return (
        <Fragment>
            <Form
                form={form}
                colon={false}
                onFinish={onFinish}
                layout="vertical"
            >
                <div className="employee-titel employee-bulk-titel">
                    <div className="title">
                        <Link to="/configuration/employee">
                            <Row className="backArrow">
                                <Image name="backArrow.svg" />
                                <h1>Employee Bulk Upload</h1>
                            </Row>
                            <p>Upload and Add Employee.</p>
                        </Link>
                    </div>
                    <div className="txt-right">
                        <Button htmlType="submit" loading={Loading}>
                            <Image className="save-img" name="save.svg" />
                            Verify & Upload
                        </Button>
                    </div>
                </div>

                {/* Loop through the csvData and create input fields for each employee */}
                <div className='common-table bulk-upload-table'>
                    <table>
                        <thead>
                            <tr>
                                <th>Card ID</th>
                                <th>Employee Name</th>
                                <th>Fin No</th>
                                <th>Contact Number</th>
                                <th>Designation</th>
                                <th>Contractor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {csvData.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                    <Form.Item
                                        name={`employeeCode_${index}`}
                                        rules={[{ required: true, message: "Enter the card ID!" }]}
                                        validateStatus={serverErrors?.employeeCode?.[index] ? "error" : ""}
                                        help={serverErrors?.employeeCode?.[index]}
                                    >
                                        <Input
                                            placeholder="Card ID"
                                            maxLength={40}
                                            onChange={() => handleInputChange(index, 'employeeCode')}
                                        />
                                    </Form.Item>
                                    </td>
                                    <td>
                                    <Form.Item
                                        name={`employeeName_${index}`}
                                        rules={[{ required: true, message: "Enter the employee name!" }]}
                                        validateStatus={serverErrors?.employeeName?.[index] ? "error" : ""}
                                        help={serverErrors?.employeeName?.[index]}
                                    >
                                        <Input
                                            placeholder="Employee Name"
                                            maxLength={40}
                                            onChange={() => handleInputChange(index, 'employeeName')}
                                        />
                                    </Form.Item>
                                    </td>
                                    <td>
                                    <Form.Item
                                        name={`finNo_${index}`}
                                        rules={[{ required: true, message: "Enter the employee Fin No!" }]}
                                        validateStatus={serverErrors?.finNo?.[index] ? "error" : ""}
                                        help={serverErrors?.finNo?.[index]}
                                    >
                                        <Input
                                            placeholder="Fin No"
                                            maxLength={40}
                                            onChange={() => handleInputChange(index, 'finNo')}
                                        />
                                    </Form.Item>
                                    </td>
                                    <td>
                                    <Form.Item
                                        name={`contact_${index}`}
                                        rules={[{ required: true, message: "Enter the contact number!" }]}
                                        validateStatus={serverErrors?.contactNumber?.[index] ? "error" : ""}
                                        help={serverErrors?.contactNumber?.[index]}
                                    >
                                        <Input
                                            placeholder="Contact Number"
                                            maxLength={10}
                                            onChange={() => handleInputChange(index, 'contact')}
                                        />
                                    </Form.Item>
                                    </td>
                                    <td>
                                    <Form.Item
                                        name={`designation_${index}`}
                                        rules={[{ required: true, message: "Enter the employee designation!" }]}
                                        validateStatus={serverErrors?.designation?.[index] ? "error" : ""}
                                        help={serverErrors?.designation?.[index]}
                                    >
                                        <Input
                                            placeholder="Designation"
                                            maxLength={40}
                                            onChange={() => handleInputChange(index, 'designation')}
                                        />
                                    </Form.Item>
                                    </td>
                                    <td>
                                    <Form.Item
                                        name={`company_${index}`}
                                        rules={[{ required: true, message: "Enter the company!" }]}
                                        validateStatus={serverErrors?.companyName?.[index] ? "error" : ""}
                                        help={serverErrors?.companyName?.[index]}
                                    >
                                        <Input
                                            placeholder="Contractor"
                                            maxLength={40}
                                            onChange={() => handleInputChange(index, 'company')}
                                        />
                                    </Form.Item>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
    
            </Form>
        </Fragment>
    );
};

export default FormEmployee;
